<template>
<div>
    <div class="px-5 pt-2 pb-5">
        <div class="row">
            <div class=" btn-home  col-md-12 mt-3 mb-4 d-flex justify-content-end">
                <button type="button" class="btn btn-outline-main" @click="returnHome">
                    <i class="fas fa-home-lg-alt"></i> Inicio
                </button>
            </div>
        </div>
        <div id="div-modal-anular" class="w-100">
            <div id="div-anular" class="card w-100">
                <div class="text-center card-header text-white h4 bg-main">
                    <strong>ORDEN DE COMPRA</strong>
                </div>
                 
                    <div class="w-100 border-box-main pt-4" style="background-color: #f2f4f4">
                        <div class="d-flex responsive-search px-4">
                            <!-- <div class="input-group input-group mb-3">
                                <span class="input-group-text text-white bg-main"><i class="fas fa-search"></i></span>
                                <input v-model="filter.molecula" @keyup.enter="mtdChangeFilter()" type="text" class="form-control form-control" style="background-color: #f9e79f" placeholder="Nombre / molécula / comercial / marca" />
                            </div>
                            <div class="input-group input-group mb-3 mx-lg-1 w-25">
                                <span class="input-group-text text-white bg-main"><i class="fas fa-search"></i></span>
                                <input v-model="filter.proveedor" @keyup.enter="mtdChangeFilter()" type="text" class="form-control form-control" style="background-color: #aed6f1" placeholder="PROVEEDOR" />
                            </div>
                            <div class="input-group input-group mb-3 me-lg-1 w-25">
                                <span class="input-group-text text-white bg-main"><i class="fas fa-search"></i></span>
                                <input v-model="filter.ruc" @keyup.enter="mtdChangeFilter()" type="text" class="form-control form-control" style="background-color: #abebc6" placeholder="RUC" />
                            </div> -->
                            <div class="input-group input-group mb-3 w-25">
                                <span class="input-group-text text-white bg-main" @click="mtdChangeFilterOC()"><i class="fas fa-search"></i></span>
                                <input v-model="filter_oc_id" type="text" class="form-control form-control" style="background-color: #f5b7b1" placeholder="O.C." />
                            </div>
                        </div>
                        <div class="cuerpo">
                            <OC v-if="page == 'oc'" :dataordersPendientes="DataordersPendientes" :filter_oc="filter_oc_id" />
                            <!-- <Medicamento v-if="page == 'medicamento'" :providerOc="providerOc" :medicaments="Medicaments" @mtdAddItemCarrito="mtdAddItemCarrito" :carrito="carritoOc" @registro-exitoso="manejarRegistroExitoso" @mtdviewcarrito="mtdviewcarrito" /> -->
                        </div>
                    </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import {
    mapActions
} from "vuex";
import OC from "@/components/Proveedor/Pages/Ordendecompra/Ocpendiente.vue";
/* import Medicamento from "@/components/Logistica/pages/Ordendecompra/Medicamento.vue";
import Others from "@/components/Logistica/pages/Ordendecompra/Otros.vue"; */

export default {
    name: "c-Proveedor-ocompra",
    data() {
        return {
            filter: {
                molecula: "",
                proveedor: "",
                ruc: "",
            },
            money : {},
            fiter_oc: '',
            filter_oc_id: "",
            Medicaments: [],
            page: "ocompra",
            DataordersPendientes: [],
            ordenCompras: [],
            itemOrdemCompra: {
                cabecera: {},
                detalle: [],
            },

            providerOc: {
                name: "",
                id: null,
            },
            carritoOc: [],
            itemCarrito: [],
            numcarrito: null,
        };
    },
    components: {
        OC,
    },

    created() {
        this.mtdChangeFilterOC();
    },
    methods: {
        ...mapActions(["get", "post"]),
        returnHome: function () {
            this.$emit("mtdChangePage", 'home');
        },
        changePage(page) {
            this.$emit("changePage", page);
        },
        mtdHide() {
            (this.filter = {
                molecula: "",
                proveedor: "",
                ruc: "",
            }),
            (this.filter_id = "");
        },
        mtdChangeFilter() {
            this.page = "medicamento";
            this.post({
                    url: this.$store.getters.get__url + "/ordendecompra/detalles/filter",
                    token: this.$store.getters.get__token,
                    params: this.filter,
                })
                .then((response) => {
                    this.reformatData(response.data);
                    this.mtdHide();

                })
                .catch((errors) => {});
        },
        reformatData(data) {
            const reformattedData = [];
            data.forEach((product) => {
                if (product.proveedor) {
                    const newProduct = {
                        id: product.id,
                        molecule: product.molecule,
                        dosis: product.dosis,
                        commercial: product.commercial,
                        cargado: product.cargado,
                        brand: product.brand,
                        presentation: product.presentation,
                        concentration: product.concentration,
                        format: product.format,
                        sub_sub_category_id: product.sub_sub_category_id,
                        precio_farmacia_kairos: product.precio_farmacia_kairos,
                        proveedor: {
                            id: product.proveedor.id,
                            name: product.proveedor.name,
                            ruc: product.proveedor.ruc,
                            email: product.proveedor.email ?? '',
                            address: product.proveedor.address ?? '',
                            phone: product.proveedor.phone ?? '',
                            credit: product.proveedor. credit ?? '',
                            expiration_days: product.proveedor.expiration_days ?? '',
                        },
                        precio_purchase: product.proveedor.price_purchase,
                        units: product.units,
                        precio_unitario: 0,
                        utilidad: parseFloat(product.precio_farmacia_kairos - product.proveedor.price_purchase).toFixed(2),
                    };
                    reformattedData.push(newProduct);
                }
            });
            this.Medicaments = reformattedData;

        },
        mtdChangeFilterOC() {
            this.page = "oc";
        },
        mtdTypeChanges() {
            this.post({
                    url: this.$store.getters.get__url + "/logistics/typeChanges",
                    token: this.$store.getters.get__token,
                })
                .then((response) => {
                    this.modalCarrito.valorType = response.compra;
                    this.modalCarrito.valorTypeVen = response.venta;
                })
                .catch((errors) => {});
        },
        mtdInsertData: function () {
            this.carritoOc.forEach((carro) => {
                carro.detalle.forEach((detalleItem, ind) => {
                    detalleItem.formatedit = !detalleItem.format ?
                        detalleItem.formatedit :
                        detalleItem.format;
                    detalleItem.dosisedit = !detalleItem.dosis ?
                        detalleItem.dosisedit :
                        detalleItem.dosis;
                });
            });

            this.post({
                    url: this.$store.getters.get__url + "/ordendecompra/store",
                    token: this.$store.getters.get__token,
                    params: {
                        carrito: this.carritoOc,
                        type: this.money.type,
                        name: this.money.name,
                    },
                })
                .then((response) => {
                    if (response.statusCode == 200) {
                        for (let index = 0; index < response.data.length; index++) {
                            const element = response.data[index];
                            window.open(
                                this.$store.getters.get__url +
                                "/ordendecompra/viewpdf/" +
                                element,
                                "_blank"
                            );
                        }
                        Swal.fire({
                            title: "Registro Exitoso",
                            text: "Perfecto!",
                            icon: "success",
                            width: "400px",
                            confirmButtonColor: "rgb(170, 2, 95)",
                        });
                        this.manejarRegistroExitoso();
                    } else {
                        Swal.fire({
                            title: "Registro Incorrecto!",
                            text: "Error!",
                            icon: "error",
                            confirmButtonColor: "rgb(170, 2, 95)",
                        });
                    }
                })
                .catch((errors) => {});
        },
    },
};
</script>
